import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import AppAlert from './plugins/appAlert'
import SnackTone from './plugins/snackTone'
import router from './router'
import axios from 'axios'
import store from './store'
import PageLoader from './components/Common/PageLoader'
import VueElementLoading from "vue-element-loading";
import ServerError from './components/Common/500'
Vue.component("VueElementLoading", VueElementLoading);
import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component(VueCropper);
import CryptoJS from 'crypto-js';
Vue.use(CryptoJS)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
Vue.component('PageLoader', PageLoader)
Vue.component('ServerError', ServerError)
Vue.config.productionTip = false
Vue.use(AppAlert)
Vue.use(SnackTone)

// Live url
window.axios = require('axios')
axios.defaults.baseURL = 'https://filmapi.forest.kerala.gov.in/'
Vue.prototype.baseURL = "https://filmapi.forest.kerala.gov.in/"
Vue.prototype.mediaURL = "https://filmapi.forest.kerala.gov.in/file/get?key="
Vue.prototype.mediaURLnew = "https://filmapi.forest.kerala.gov.in/wp?key="

// window.axios = require('axios')
// axios.defaults.baseURL = 'https://l6v8f8f0-4002.inc1.devtunnels.ms/'
// Vue.prototype.baseURL = "https://l6v8f8f0-4002.inc1.devtunnels.ms/"
// Vue.prototype.mediaURL = "https://l6v8f8f0-4002.inc1.devtunnels.ms/file/get?key="
// Vue.prototype.mediaURLnew = "https://l6v8f8f0-4002.inc1.devtunnels.ms/wp?key="  

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://localhost:4002'
// Vue.prototype.baseURL = "http://localhost:4002/"
// Vue.prototype.mediaURL = "http://localhost:4002/file/get/"
// Vue.prototype.mediaURLnew = "http://localhost:4002/wp?key="

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.53.241:4002'
// Vue.prototype.baseURL = "http://192.168.53.241:4002/"
// Vue.prototype.mediaURL = "http://192.168.53.241:4002/file/get/"
// Vue.prototype.mediaURLnew = "http://192.168.53.241:4002/wp?key="

// window.axios = require('axios')
// axios.defaults.baseURL = 'https://servicefilmapi.forest.kerala.gov.in/'
// Vue.prototype.baseURL = "https://servicefilmapi.forest.kerala.gov.in/"
// Vue.prototype.mediaURL = "https://servicefilmapi.forest.kerala.gov.in/file/get?key="
// Vue.prototype.mediaURLnew = "https://servicefilmapi.forest.kerala.gov.in/wp?key="


new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

let inactivityTimer = null;
const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes in milliseconds

function resetInactivityTimer() {
  if (inactivityTimer) clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    // Call logoutUser mutation from store
    if (store.state.isLoggedIn) {
      store.commit('logoutUser');
    }
  }, INACTIVITY_LIMIT);
}

// Listen for user activity
['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach(event => {
  window.addEventListener(event, resetInactivityTimer);
});

// Start timer on app load
resetInactivityTimer();
